import React from "react";
import "./homepage.css";
import Projects from "../Projects/Projects";
import Contacts from "../Contacts/Contacts";
import Footer from "../Footer/Footer";
import { VimeoCoverVideo } from "./VimeoCoverVideo";

export class Homepage extends React.Component {
  render() {
    return (
      <div className="homepage">
        <VimeoCoverVideo />
        <Projects />
        <Contacts />
        <Footer />
      </div>
    );
  }
}

export default Homepage;



// WEBPACK FOOTER //
// ./src/components/Homepage/Homepage.js